import loadable from '@loadable/component';

export const SalaryReportLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "SalaryReport" */
      './SalaryReport.dynamic'
    ),
);
